import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CardsDisplayMode } from '../../enums/cards-display-mode.enum';
import { CardItem } from '../../models/card-item';
import { ConfigService } from 'nm-socle-application/app/services/config.service';
import { CardsSize } from '../../enums/cards-size.enum';

@Component({
    selector: 'cards-item',
    templateUrl: './cards-item.component.html',
    styleUrls: ['./cards-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardsItemComponent implements OnInit, OnDestroy, CardItem {
    @Input() public active: boolean = true;
    @Input() public dir: string;

    @Input() public id: string;
    @Input() public title: string;
    @Input() public description: string;
    @Input() public icon: string;
    @Input() public image: string;

    @Input() public color: string;
    @Input() public cardsMode: CardsDisplayMode = CardsDisplayMode.CARDS;
    private _cardsSize: CardsSize = CardsSize.MEDIUM;

    @Input() public clickAction: Function;
    @Input() public dblClickAction: Function;

    @Input() public isSelected: boolean = false;
    @Input() public showSubtitle: boolean = true;

    @Input() public anotherHasImage: boolean = false;

    public sizeClassName: string = 'size-medium';
    private sizeClasses: any[] = [{ key: CardsSize.SMALL, value: 'size-small' }, { key: CardsSize.MEDIUM, value: 'size-medium' }, { key: CardsSize.LARGE, value: 'size-large' }, { key: CardsSize.XLARGE, value: 'size-xlarge' }];

    public cardDisplayModeCards: CardsDisplayMode = CardsDisplayMode.CARDS;
    public cardDisplayModeTiles: CardsDisplayMode = CardsDisplayMode.TILES;

    @Input()
    public get cardsSize(): CardsSize {
        return this._cardsSize;
    }
    public set cardsSize(value: CardsSize) {
        this._cardsSize = value;

        let targetClass: string = 'size-medium';

        for (let size of this.sizeClasses) {
            if (size.key == value) {
                targetClass = size.value;
                break;
            }
        }

        this.sizeClassName = targetClass;
    }

    constructor(private _configService: ConfigService) {
    }

    public ngOnInit() {
        if (!this.dir)
            this.dir = this._configService.get('nmaps_image_dir_uri').value;
    }

    public ngOnDestroy() {
    }

    public doClickAction() {
        if (this.clickAction != undefined && this.clickAction != null) {
            this.clickAction(this);
        }
    }

    public doDblClickAction() {
        if (this.dblClickAction != undefined && this.dblClickAction != null) {
            this.dblClickAction(this);
        }
    }

    public get hasSubtitle(): boolean {
        return this.showSubtitle && this.description != undefined && this.description != '';
    }

    public imageError(event) {
        this.image = undefined;
    }

    public iconError(event) {
        this.icon = undefined;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/components/cards-item/cards-item.component.ts